export default __webpack_public_path__ + "static/media/cartNew.a997df44.svg";